export default __webpack_public_path__ + "media/8afd8702cb1c18701e0b8bd7797776de.png";